import styled from 'styled-components';

const TableContainer = styled.div`
    width: 100%;
    height: 100%;
    font-size: 90%;
    @media (max-width: 1200px) {
        font-size: 80%;
    }
    overflow: auto;
`;

const tblBorder = `1px solid #999`;

const StyledTable = styled.table`
    max-width: 100%;
    border-collapse: separate;
    border-spacing: 0;

    & td,
    & th {
        border: ${tblBorder};
        border-left: none;
        border-top: none;
        padding: 2px 8px;
    }

    & td:first-child,
    & th:first-child {
        border-left: ${tblBorder};
    }

    & thead tr:first-child td,
    & thead tr:first-child th {
        border-top: ${tblBorder};
    }

    & th {
        text-align: left;
    }

    & thead {
        position: sticky;
        top: 0;
        background-color: #ddd;
        z-index: 1;
    }

    & thead th:first-child {
        position: sticky;
        left: 0;
        top: 0;
        z-index: 2;
        background: #ddd;
    }

    & tbody th {
        position: sticky;
        left: 0;
        background-color: #ddd;
    }

    & td {
        text-align: right;
        white-space: nowrap;
    }
`;

const ResultsTable = ({ data }) => {
    if (!data || data.length < 1) return null;

    let [{ usertoken, player, ...firstD }] = data;

    const parameterGroups = Object.entries(firstD).map(([grpKey, grpValue]) => {
        return {
            header: grpKey,
            data: Object.entries(grpValue).map(([paramKey]) => {
                return {
                    parameterLabel: paramKey,
                    data: data.map((userData) => {
                        return userData[grpKey]?.[paramKey];
                    }),
                };
            }),
        };
    });

    return (
        <TableContainer>
            <StyledTable>
                <colgroup>
                    <col span="1" style={{ minWidth: 200 }} />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        {data.map((d) => (
                            <th key={d.usertoken}>{d.player}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {parameterGroups.map((group) => {
                        return [
                            <tr key={group.header}>
                                <th>{group.header}</th>
                                <td colSpan={data.length}></td>
                            </tr>,
                            group.data.map((rowData, i) => {
                                return (
                                    <tr key={i}>
                                        <th>{rowData.parameterLabel}</th>
                                        {rowData.data.map((d, i) => (
                                            <td key={i}>{d}</td>
                                        ))}
                                    </tr>
                                );
                            }),
                        ];
                    })}
                </tbody>
            </StyledTable>
        </TableContainer>
    );
};

export default ResultsTable;
